import kebabCase from 'lodash/kebabCase';
import { domain } from 'modules/data';
import { Path } from 'urlBuilder';

export const createHelpItemId = (integrationType?: domain.IntegrationType) => {
    return `${kebabCase(Path.bankAccounts)}-${integrationType ?? domain.IntegrationType.None}`;
};
